import { render, staticRenderFns } from "./SystemWhatsappTemplates.vue?vue&type=template&id=4a88dc62&scoped=true"
import script from "./SystemWhatsappTemplates.vue?vue&type=script&lang=js"
export * from "./SystemWhatsappTemplates.vue?vue&type=script&lang=js"
import style0 from "./SystemWhatsappTemplates.vue?vue&type=style&index=0&id=4a88dc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88dc62",
  null
  
)

export default component.exports